import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, Col, Container } from 'reactstrap'
import { BackButton } from '../../../components/Common/BackButton'
import Breadcrumb from '../../../components/Common/Breadcrumb'
import { SearchBar } from '../../../components/Common/SearchBar'
import Table1 from "../../../components/Common/TableContainer"
import { getStatusSamples } from '../../../store/actions'

export const CatalogLayoutEssaysState = (props) => {

    // * Redux
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getStatusSamples("?limit=20&page=0"))
        
    }, [])

    const { statusSamples, loading, total, currentPage } = useSelector(state => ({
        statusSamples: state.statusReducer.statusSamples,
        loading: state.statusReducer.loading,
        statusSample: state.statusReducer.statusSample,
        total: state.statusReducer.total,
        currentPage: state.statusReducer.currentPage
    }));
    // * Redux fin

    // Modal HOOKS
    const [isUpdate, setIsUpdate] = useState(false);
    const [rowInfo, setRowInfo] = useState();
    const [showModal1, setShowModal1] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [searchData, setSearchData] = useState('');

    useEffect(() => {
        dispatch(getStatusSamples(`?limit=20&page=0&search=${searchData}`))
    }, [searchData])
    
    const columns = React.useMemo(
        () => [
            {
                Header: 'Estado de la muestra',
                width: '100%',
                Cell: ({ row }) => (
                    <div>
                        <div className='text-left'>{row.original.items ?? '-'}</div>
                    </div>
                ),
            },
        ],
        []
    )

    const getPagination = (params) => {
        dispatch(getStatusSamples(`${params}&search=${searchData}`))
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="" >
                    <Col className="col-12" style={{ padding: 40 }}>
                        <Card className='' style={{ padding: 20 }}>

                            <Breadcrumb breadcrumbItem1='catalogsmenu' breadcrumbItem2='EssaysStateCatalog' />

                            <Card className='' style={{ padding: 20 }}>

                                <BackButton props={props} />

                                <div className="d-flex justify-content-between">
                                    <SearchBar setSearchData={setSearchData} />
                                </div>

                                <Table1 currentPage={currentPage} getPagination={getPagination} total={total} loading={loading} isAddTableBorderStrap columns={columns} data={statusSamples} />
                            </Card>

                            <br />
                            <br />

                        </Card>
                    </Col>
                </Container>
            </div>
        </React.Fragment>
    )
}
